import 'css-chunksrc/client/scenes/inviteMembers/member/languageSelection/styles.scss';export default {
  "roleSelection": "_roleSelection_1wndj_1",
  "input": "_input_1wndj_5",
  "langIcon": "_langIcon_1wndj_20",
  "selection": "_selection_1wndj_25",
  "placeholder": "_placeholder_1wndj_31",
  "list": "_list_1wndj_36",
  "language": "_language_1wndj_51",
  "iconBox": "_iconBox_1wndj_67",
  "icon": "_icon_1wndj_67",
  "opened": "_opened_1wndj_78",
  "selectedLanguage": "_selectedLanguage_1wndj_86",
  "disabled": "_disabled_1wndj_90",
  "invalid": "_invalid_1wndj_97"
};